export function updateCounters() {
    var findProjectFilters = jQuery(
        '.TypeFindProject__filters .TypeFindProject__filter'
    );

    for (var i = 0; i < findProjectFilters.length; i++) {
        var filter = jQuery(findProjectFilters[i]);
        var counter = jQuery('.' + filter.data('target-dropdown'));

        if (counter.length > 0) {
            var totalChecked = counter
                .find('.FilterBar__select:checked')
                .not('.FilterBar__select--all').length;

            filter.find('.FilterBar__selected-counter-sub').text(totalChecked);

            if (totalChecked === 0) {
                filter.find('.js-trigger-counter').hide();
            } else {
                filter.find('.js-trigger-counter').show();
            }
        }
    }

    var cats = jQuery('.FilterBar__category');

    for (var i = 0; i < cats.length; i++) {
        var cat = jQuery(cats[i]);
        var counter = cat.find('.FilterBar__selected-counter-sub');

        if (counter.length > 0) {
            var totalChecked = cat
                .find('.FilterBar__select:checked')
                .not('.FilterBar__select--all').length;

            counter.text(totalChecked);

            if (totalChecked === 0) {
                cat.find('.js-trigger-counter').hide();
            } else {
                cat.find('.js-trigger-counter').show();
            }
        }
    }

    var subCats = jQuery('.Filter-Category__option');

    for (var j = 0; j < subCats.length; j++) {
        var subCat = jQuery(subCats[j]);
        if (subCat.find('.FilterBar__select-counter').length > 0) {
            var total = subCat
                .find('.FilterBar__select')
                .not('.FilterBar__select--all')
                .not(':disabled').length;
            var totalChecked = subCat
                .find('.FilterBar__select:checked')
                .not('.FilterBar__select--all')
                .not(':disabled').length;

            var selectAll = subCat.find('.FilterBar__select--all');

            if (total > 0) {
                selectAll.prop('checked', total === totalChecked);
            }

            selectAll.prop(
                'indeterminate',
                totalChecked > 0 ? total !== totalChecked : false
            );

            subCat.find('.FilterBar__counter-selected').text(totalChecked);
            subCat.find('.FilterBar__counter-total').text(total);
        }
    }

    var totalChecked = jQuery('.FilterBar__select:checked').not(
        '.FilterBar__select--all'
    ).length;
    jQuery('.FilterBar__selected-counter-all').text(totalChecked);
}

export function checkedChildrenEnabled() {
    var subCats = jQuery('.Filter-Category__option');

    for (var j = 0; j < subCats.length; j++) {
        var subCat = jQuery(subCats[j]);
        if (subCat.find('.FilterBar__select-counter').length > 0) {
            var total = subCat
                .find('.FilterBar__select')
                .not('.FilterBar__select--all').length;
            var totalDisabled = subCat
                .find('.FilterBar__select:disabled')
                .not('.FilterBar__select--all').length;

            subCat
                .find('.FilterBar__select--all')
                .prop('disabled', total === totalDisabled);
        }
    }
}

export function openProductsFilter(event) {
    if (!checkWindowWidth()) event.preventDefault();

    var selected = jQuery(this),
        selectedTrigger = selected;

    // Slight hack to get the the actual trigger element (For Homepage search) (To save time)
    var targetDropDownTrigger = selected.attr('data-target-dropdown-trigger');
    if (targetDropDownTrigger) {
        selectedTrigger = jQuery('.' + targetDropDownTrigger);
    }

    var selectedNav = selected.siblings('.FilterBar-nav').first();

    // Slight hack to get the the actual dropdown element (For Homepage search) (To save time)
    var targetDropDown = selected.attr('data-target-dropdown');
    if (targetDropDown) {
        selectedNav = jQuery('.' + targetDropDown).first();
    }

    jQuery('.FilterBar-nav')
        .not(selectedNav)
        .addClass('is-hidden');
    jQuery('.FilterBar__dropdown-trigger').removeClass('selected');
    jQuery('.FilterBar__categories').removeClass('moves-out');

    if (selectedNav.hasClass('is-hidden')) {
        //desktop version only
        selectedTrigger
            .addClass('selected')
            .siblings('ul')
            .first()
            .removeClass('is-hidden')
            .end()
            .parent('.has-subnav')
            .parent('ul')
            .addClass('moves-out');
        selectedTrigger
            .parent('.has-subnav')
            .siblings('.has-subnav')
            .children('ul')
            .addClass('is-hidden')
            .end()
            .children('a')
            .removeClass('selected');
        jQuery('.FilterBar-overlay').addClass('is-visible');
    } else {
        selectedTrigger
            .removeClass('selected')
            .siblings('ul')
            .first()
            .addClass('is-hidden')
            .end()
            .parent('.has-subnav')
            .parent('ul')
            .removeClass('moves-out');
        jQuery('.FilterBar-overlay').removeClass('is-visible');
    }

    if (window.innerWidth < 900) {
        jQuery('#hubspot-messages-iframe-container').addClass('js-livechat-hidden');
    }
}

export function closeBar() {
    jQuery('body').removeClass('prevent-mobile-scroll');
    jQuery('.FilterBar-overlay').removeClass('is-visible');
    jQuery('.FilterBar-trigger').removeClass('bar-is-visible');
    jQuery('.cd-main-header').removeClass('bar-is-visible');
    jQuery('.FilterBar').removeClass('bar-is-visible');
    jQuery('.has-subnav .FilterBar-nav').addClass('is-hidden');
    jQuery('.has-subnav a').removeClass('selected');
    jQuery('.moves-out').removeClass('moves-out');
    jQuery('.main-content')
        .removeClass('bar-is-visible')
        .one(
            'webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend',
            function() {
                jQuery('body').removeClass('overflow-hidden');
            }
        );

    jQuery('.FilterBar__back')
        .parent()
        .parent('ul')
        .addClass('is-hidden')
        .parent('.has-subnav')
        .parent('ul')
        .removeClass('moves-out');

    jQuery('#hubspot-messages-iframe-container').removeClass('js-livechat-hidden');
}

export function scrollToFilters() {
    if (window.innerWidth >= 1170)
        jQuery('html, body').animate({
            scrollTop: jQuery('.FilterBar-trigger').offset().top - 25,
        });
}

export function showFilters(event) {
    event.preventDefault();

    var trigger = jQuery(this),
        filterBar = jQuery('.' + trigger.attr('data-target-bar'));

    scrollToFilters();

    jQuery('body').addClass('prevent-mobile-scroll');

    if (jQuery('.main-content').hasClass('bar-is-visible')) {
        closeBar();
        jQuery('.FilterBar-overlay').removeClass('is-visible');
    } else {
        trigger.addClass('bar-is-visible');
        filterBar.addClass('bar-is-visible').removeClass('is-hidden');
        jQuery('.cd-main-header').addClass('bar-is-visible');
        jQuery('.main-content')
            .addClass('bar-is-visible')
            .one(
                'webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend',
                function() {
                    // Only hide overflow of body if the trigger isn't for the Find your Project filter bar
                    if (!trigger.hasClass('TypeFindProject__filter')) {
                        jQuery('body').addClass('overflow-hidden');
                    }
                }
            );
        window.pa.megamenu.toggleSearch('close');
        jQuery('.FilterBar-overlay').addClass('is-visible');

        if (trigger.hasClass('FilterBar-trigger--sort-by')) {
            filterBar.find('.FilterBar__dropdown-trigger').trigger('click');
        }
    }
}

function checkWindowWidth() {
    //check window width (scrollbar included)
    var e = window,
        a = 'inner';
    if (!('innerWidth' in window)) {
        a = 'client';
        e = document.documentElement || document.body;
    }
    return e[a + 'Width'] >= global.mediaQueryWidth;
}
